import React from 'react';
import styles from './styles.module.scss';

type SubtituloSeccionProps = {
    children?: React.ReactNode
    fontSize?: string
    align?: React.CSSProperties['textAlign']
    style?: React.CSSProperties
}

const SubtituloSeccion = ({ children, fontSize, align, style }: SubtituloSeccionProps) => {
  return (
    <h2
      className={styles.titulo}
      style={{ fontSize: fontSize ?? '1rem', textAlign: align ?? 'left', ...style }}
    >
      {children}
    </h2>
  );
};

export default SubtituloSeccion;
